import { apiService } from "@base/configs";
import httpService from "@base/services/httpService";
import { IDoctor, IDoctorPage, IDoctorRatingPage, ITimeTable } from "./interface/doctor.interface";
import IFilterDcotor from "./interface/filterDoctor.interafce";

class DoctorService {
  // get list
  getList(parmas?: IFilterDcotor) {
    return httpService.get<IDoctorPage>(`${apiService.doctor.getList}`, {
      params: parmas,
    });
  }

  getByCodeLess(doctorCode: string) {
    return httpService.get(`${apiService.doctor.getByCodeLess}/${doctorCode}`);
  }

  getBySlug(slug: string, lang?: string) {
    return httpService.get<IDoctor>(`${apiService.doctor.getBySlug}/${slug}`, { params: { lang } });
  }

  // A doctor's ratings. Needs a session, and pages with `pager`/`size` rather than the usual names.
  getRatings(doctorCode: string, pager: number, size: number) {
    return httpService.get<IDoctorRatingPage>(`${apiService.doctor.ratings}/${doctorCode}`, {
      params: { pager, size },
    });
  }

  // get time table
  getTimeTable(doctor_code: string, assign_date: string) {
    return httpService.get<ITimeTable>(`${apiService.doctor.timeTable.getAllByDoctorCodeAndDate}/${doctor_code}`, {
      params: { assign_date },
    });
  }
}

export default new DoctorService();
